import { useNavigate } from "react-router-dom";
import { Headset, SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "@/components/ui/dialog";
import images from "../../assets/image-export-assets";

type Props = {
  inCase: boolean;
  isOpen: boolean;
  onClose: () => void;
  onUpgrade?: () => void;
};

export const FreeTrialEndedModal: React.FC<Props> = ({
  inCase,
  isOpen,
  onClose,
  onUpgrade
}) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      window.open("/pricing", "_blank");
    }
  };

  const handleCancel = () => {
    navigate("/");
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) handleCancel();
      }}
    >
      <DialogContent
        showCloseButton={false}
        className="sm:max-w-125"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>
            {inCase ? "Upgrade Case" : "Free Trial Ended"}
          </DialogTitle>
          <DialogDescription className="text-fg-2">
            Upgrade to CaseBlink's Premium Plan to maintain full access to trial
            cases, receive additional cases, and continue enjoying:
          </DialogDescription>
        </DialogHeader>

        {/* Features List - reused from FreeTrialPopup */}
        <ul className="flex flex-col gap-2 text-base text-fg-2">
          <li className="flex items-center gap-2">
            <img
              src={images.aiGenerate}
              alt="AI Generate Icon"
              className="size-5"
            />
            <span>
              <span className="font-medium text-fg">
                The most advanced AI Tools
              </span>{" "}
              for end-to-end case preparation
            </span>
          </li>
          <li className="flex items-center gap-2">
            <SlidersHorizontal className="size-4 text-accent-seed" />
            <span className="font-medium text-fg">
              New Exclusive AI Workflow Features
            </span>
          </li>
          <li className="flex items-center gap-2">
            <Headset className="size-4 text-accent-seed" />
            <span>
              <span className="font-medium text-fg">Enhanced Support</span>{" "}
              whenever you need assistance
            </span>
          </li>
        </ul>

        <DialogFooter>
          <Button variant="ghost" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpgrade}>
            Upgrade Now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
